import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export function AdminDashboardPaginatedSection<T>({
    rows,
    page,
    pageSize,
    total,
    totalPages,
    onPageChange,
    render,
}: {
    rows: T[];
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    render: (rows: T[]) => JSX.Element;
}) {
    const safePage = Math.min(Math.max(page, 1), totalPages);
    const firstRow = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
    const lastRow = Math.min((safePage - 1) * pageSize + rows.length, total);

    return (
        <div className="space-y-3">
            {render(rows)}
            {total > pageSize && (
                <nav
                    aria-label="Pagination"
                    className="flex flex-col gap-2 rounded-xl border bg-white px-4 py-3 text-sm tabular-nums text-neutral-600 sm:flex-row sm:items-center sm:justify-between"
                >
                    <span className="whitespace-nowrap" aria-live="polite">
                        Showing {firstRow}-{lastRow} of {total}
                    </span>
                    <div className="flex items-center justify-between gap-2 sm:justify-start">
                        <Button
                            variant="outline"
                            size="sm"
                            disabled={safePage === 1}
                            onClick={() => onPageChange(safePage - 1)}
                        >
                            Previous
                        </Button>
                        <span className="whitespace-nowrap">
                            Page {safePage} of {totalPages}
                        </span>
                        <Button
                            variant="outline"
                            size="sm"
                            disabled={safePage === totalPages}
                            onClick={() => onPageChange(safePage + 1)}
                        >
                            Next
                        </Button>
                    </div>
                </nav>
            )}
        </div>
    );
}

export function AdminDashboardEmptyState({ message }: { message: string }) {
    return (
        <Card>
            <CardContent className="p-10 text-center text-sm text-neutral-500">
                {message}
            </CardContent>
        </Card>
    );
}
